// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBCXhqoekI0wcTeBGis0XZ_1YMENUFk8jk",
  authDomain: "back-office-delta.firebaseapp.com",
  projectId: "back-office-delta",
  storageBucket: "back-office-delta.appspot.com",
  messagingSenderId: "441018695121",
  appId: "1:441018695121:web:97ba2dc794a1024e2a34f0",
  measurementId: "G-2XY88NXECE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };